// extracted by mini-css-extract-plugin
export default {"root":"Ziq51","title":"lucyf"};